import { CONFIRM_COLOR, CONFIRM_ICONS, TYPE_MODAL } from '../modal-confirm-notification';

export const DELETE_HOLIDAY_EXCEPTION = {
    typeModal: TYPE_MODAL.NOTIFICATION,
    title: '¿Está seguro que desea eliminar la excepción registrada?',
    valueButton: 'Eliminar',
    color: CONFIRM_COLOR.WARN,
    icon: CONFIRM_ICONS.CANCEL
  };
